import { EditProductFormReducerState } from 'reducers/EditProductReducer/EditProductReducer'
import { getType } from 'utils'

export interface ClaimsTypes {
  claim: string
  disclaimer: string
}

export const extractClaims = (keyphrases_with_disclaimers: string[] | undefined): ClaimsTypes[] => {
  if (!keyphrases_with_disclaimers) return []

  return keyphrases_with_disclaimers.reduce((acc: ClaimsTypes[], _, index, array) => {
    if (index % 2 === 0) {
      acc.push({ claim: array[index] || '', disclaimer: array[index + 1] || '' })
    }
    return acc
  }, [])
}
export const mainRequiredFields = getType<(keyof EditProductFormReducerState)[]>(['reference_name', 'product_id'])
export const attributesFields = getType<(keyof EditProductFormReducerState)[]>([
  'brand',
  'product_name',
  'product_types',
  'range',
  'product_description',
  'product_features',
  'instructions',
  'quantity',
  'size',
  'colour',
  'flavour',
  'format',
  'formulation',
  'product_dimensions',
  'pack_count',
  'model_number',
])
